import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useNavigate } from 'react-router-dom';
import { tutorialsAPI } from '../../services/api';

/**
 * "Watch tutorial" for a screen. It asks the server which tutorial belongs to this screen and renders nothing when there is none
 * the person may play (not published, no video yet, or not allowed), so a screen never shows a dead link.
 */
const WatchTutorialLink: React.FC<{ contextKey: string }> = ({ contextKey }) => {
  const navigate = useNavigate();
  const [found, setFound] = useState<{ slug: string; title: string } | null>(null);
  useEffect(() => {
    let alive = true;
    void (async () => { try { const r = await tutorialsAPI.resolveContext(contextKey); if (alive) setFound(r); } catch { if (alive) setFound(null); } })();
    return () => { alive = false; };
  }, [contextKey]);
  if (!found) return null;
  return <Button size="small" startIcon={<PlayCircleOutlineIcon />} onClick={() => navigate(`/help/${found.slug}`)}>Watch tutorial</Button>;
};

export default WatchTutorialLink;
